import axios, { AxiosError } from 'axios';

import { MenuItem } from '@tassomutuo-backoffice/types';
import { axiosApiInstancePrivate } from '../index';
import configEnv from '../../../config/config';

interface ICreateMenuItem {
  name: string;
  page?: string;
  subItems: { name: string; page: string }[];
}

export const createMenuItem = async (data: ICreateMenuItem): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.post(`/v1/menu`, data);

    return response.data?.results || [];
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const updateMenuItem = async ({
  menuItemId,
  data,
}: {
  menuItemId: string;
  data: ICreateMenuItem;
}): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.patch(
      `/v1/menu/${menuItemId}`,
      data
    );

    return response.data?.results || [];
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getMenuItemsInProd = async (): Promise<MenuItem[]> => {
  try {
    const response = await axios.get<MenuItem[]>(
      `${configEnv.apiUrlTassoProduction}/v1/menu`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getMenuItems = async (): Promise<MenuItem[]> => {
  try {
    const response = await axiosApiInstancePrivate.get<MenuItem[]>(`/v1/menu`);

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const deleteMenuItem = async (id: string): Promise<MenuItem> => {
  try {
    const response = await axiosApiInstancePrivate.delete<MenuItem>(
      `/v1/menu/${id}`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const changeMenuItemsOrder = async (
  data: { id: string; order: number }[]
): Promise<MenuItem[]> => {
  try {
    const response = await axiosApiInstancePrivate.post<MenuItem[]>(
      `/v1/menu/change-order`,
      data
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const publishMenuItemsInProd = async (): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.post<void>(
      `/v1/menu/publish-to-prod-client`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};
